import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  alpha
} from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { AuthService } from 'src/services/AuthService';
import { UserDetails } from 'src/models/User';
import { ManagementServices } from 'src/services/ManagementServices';
import { ShopsDetails } from 'src/models/Shops';
import { SelectedShop } from 'src/contexts/SelectedShop';
import { brand } from 'src/theme/brand';

function HeaderButtons() {
  const [selectedShop, setSelectedShop] = useState('');
  const [isUser, setUser] = useState({} as UserDetails);
  const [userShops, setUserShops] = useState<ShopsDetails[]>([]);
  const { isButtonClicked, setButtonClicked } = useContext(SelectedShop);

  useEffect(() => {
    AuthService.getMe().then((res: any) => {
      if (res.success) {
        setUser(res.data);

        if (res.data.shops && res.data.shops.length > 0) {
          fetchShops(res.data.shops);
        }
      }
    });
  }, []);

  const fetchShops = async (shops: string[]) => {
    try {
      const shopsData = await ManagementServices.getShopsByIds(shops);
      if (Array.isArray(shopsData)) {
        setUserShops(shopsData);
        const selectedShop = localStorage.getItem('selectedShop');

        if (selectedShop) {
          setSelectedShop(JSON.parse(localStorage.getItem('selectedShop'))._id);
        } else {
          localStorage.setItem('selectedShop', JSON.stringify(shopsData[0]));
          setSelectedShop(shopsData.length > 0 ? shopsData[0]._id : '');
          setButtonClicked(!isButtonClicked);
        }
      } else {
        console.error('Invalid response format:', shopsData);
      }
    } catch (error) {
      console.error('Error fetching shops:', error);
    }
  };

  const handleShopChange = (event: SelectChangeEvent<string>) => {
    const selectedId = event.target.value as string;
    setSelectedShop(selectedId);
    setButtonClicked(!isButtonClicked);
    const shop = userShops.find((item) => item._id === selectedId);

    if (shop) {
      localStorage.setItem('selectedShop', JSON.stringify(shop));
    }
  };

  if (!isUser?.shops || userShops.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        mr: { xs: 0.5, sm: 1 },
        minWidth: { xs: 140, sm: 200 },
        maxWidth: { xs: 160, sm: 240 }
      }}
    >
      <FormControl fullWidth size="small">
        <InputLabel id="header-shop-select-label">Select Shop</InputLabel>
        <Select
          labelId="header-shop-select-label"
          label="Select Shop"
          value={selectedShop}
          onChange={handleShopChange}
          displayEmpty
          inputProps={{ 'aria-label': 'Select Shop' }}
          sx={{
            borderRadius: '8px',
            backgroundColor: brand.surface,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: brand.border
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: alpha(brand.green, 0.35)
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: brand.green
            }
          }}
        >
          {userShops?.map((shop: ShopsDetails) => (
            <MenuItem key={shop._id} value={shop._id}>
              {shop.shopName}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default HeaderButtons;
